import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_translation from "./locales/en.json"; 
import fr_translation from "./locales/fr.json";  

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en_translation,
    },
    fr: {
      translation: fr_translation,
    },
  },
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;